import React, { ReactElement, useContext } from "react";

import { ActionType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/action_pb";

import { PermissionsContext } from "context/permissions-context";

interface ActionPermissionWrapperProps {
  action: ActionType;
  children:
    | ReactElement<{ disabled?: boolean }>
    | Array<ReactElement<{ disabled?: boolean }>>;
}

// Wrapper component that checks if the specified action is in the user's permissions, and disables
// child components if the specified action is not in the user's permitted actions.
const ActionPermissionWrapper = ({
  action,
  children,
}: ActionPermissionWrapperProps) => {
  const { hasPermissions, permissions } = useContext(PermissionsContext);

  return (
    <>
      {
        React.Children.map(children, (child) =>
          React.isValidElement(child)
            ? React.cloneElement(child, {
                disabled:
                  child.props.disabled ||
                  permissions.isPermissionsLoading ||
                  !hasPermissions([action]),
              })
            : child
        ) as Array<ReactElement<{ disabled?: boolean }>>
      }
    </>
  );
};

export default ActionPermissionWrapper;
